const Source = () => {
    return (
        <>
            <p className="source">
                Note: The map displays estimates for 229 metropolitan areas out
                of a total of 381 areas currently defined by the federal
                government. These 229 areas are the ones that are identifiable
                in publicly available Census Bureau datasets and for which data
                were available for both 2000 and 2014. They accounted for 76% of
                the nation’s population in 2014.
            </p>
            <p className="source">
                Source: Pew Research Center analysis of the 2014 American
                Community Survey and the 2000 Decennial Census (IPUMS)
            </p>
        </>
    );
};

export default Source;
